<template>

  <v-card>

    <v-layout id="header">
      <v-img gradient="to right, rgba(183,175,200,1), rgba(122,153,177,1), rgba(256,256,256,1)">
        <v-row>
          <v-col>
            <v-img id="logo" src="@/assets/logo.png"/>
          </v-col>  
        </v-row>
      </v-img>
    </v-layout>

    <v-img id="container" gradient="to bottom, rgba(122,153,177,0.1), rgba(122,153,177,0.1)">

      <v-card-title>Online Recommendations</v-card-title>
      <v-card-subtitle>Let's play a little game. Click the following images in order of preference. The Artificial Intelligence will search in our huge catalogue the best products for you, according to your choices.</v-card-subtitle>

      <v-card-text>
        
          <Options v-bind:title="title" v-bind:loading="loading" v-bind:options="options" v-bind:recommendations="recommendations" v-on:choice-done="nextStep"/>

      </v-card-text>

    </v-img>

  </v-card>

</template>

<script>
import Options from '@/components/views/Options.vue'
import state from '@/persistency/State.js'
import choicesApi from '@/api/choices.js'
import recommendationsApi from '@/api/recommendations.js'

export default {
  
  name: 'DemoLayout',
  
  data: function () {
    return {
      state,
      loading: false,
      recommendations: false,
      options: [{}, {}, {}]
    }
  },

  computed: {
    title: function() {

      if(!this.recommendations){
        return "Choice number "+this.state.currentStep
      } else {
        return "Chosen for you"
      }
      
    }
  },

  components: {
    Options
  },
  
  methods: {

    nextStep: function(preferences) {

      // Add those preferences
      state.addPreferences(this.state.currentStep, preferences)

      // Get the next choices
      this.getChoices()
        .catch(error => {
            if(error.response.status == 404){

              // Time for recommendations
              this.recommendations = true
              recommendationsApi.getRecommendationsAnd(
                this.state.preferences, 
                images => {
                  this.options = images
                  this.loading = false
                }
              )

            }  
          }
        )

    },

    getChoices: function() {

      this.loading = true
      return choicesApi.getChoicesAnd(
          this.state.currentStep, 
          images => {
            this.options = images
            this.loading = false
          }
        )

    }

  },

  mounted: function() {
    this.getChoices()
  }
  
}

</script>

<style scoped>

#header {
  overflow: hidden;
  height: 15vh;
}

#logo {
  width: 25vh;
  margin-left: auto;
  margin-right: 2vh;
}

#container {
  min-height: 70vh;
  margin: auto;
  padding-left: 10vh;
  padding-right: 10vh;
  padding-top: 5vh;
}

</style>
